import React, { useState, useEffect } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import Pruef_PlanActions from "../../../Actions/Pruef_PlanActions";
import pruefPlanStores from "../../../Stores/PruefPlanStore";
import pruef_PlanConstants from "../../../Constants/Pruef_PlanConstants";
import commonUtils from "../../../helpers/commonUtils";
import TemplateList from "../../ChecklistTemplates/templateList";
import { toast } from "react-toastify";

export default function AddChecklistPopUp(props) {
  const {
    setAddChecklistModalOpen,
    getCheckListDetails,
    setviewModeOnly,
    setIsChecklistFromTemplate,
    handleActionButtons,
  } = props;
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [checklistTemplateList, setChecklistTemplateList] = useState([]);
  const [showTemplateList, setShowTemplateList] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [modalClass, setModalClass] = useState(
    showTemplateList ? "custom-modal" : ""
  );
  const [disableContinueButton, setDisableContinueButton] = useState(false);
  const [selectedTemplateData, setSelectedTemplateData] = useState([]);

  const getChecklistTemplates = () => {
    Pruef_PlanActions.getChecklistTemplates();
  };

  useEffect(() => {
    function getChecklistTemplateSuccess() {
      const res = pruefPlanStores.getChecklistTemplateResult();

      if (res && res.length > 0) {
        setChecklistTemplateList(res);
      } else {
        setChecklistTemplateList([]);
      }
      setShowTemplateList(true);
      setGlobalSpinner(false);
    }
    function getChecklistTemplateFailure() {
      const res = pruefPlanStores.getChecklistTemplateResult();
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_SUCCESS,
      getChecklistTemplateSuccess
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_FAILURE,
      getChecklistTemplateFailure
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_SUCCESS,
        getChecklistTemplateSuccess
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_FAILURE,
        getChecklistTemplateFailure
      );
    };
  }, []);

  useEffect(() => {
    function deleteChecklistTemplateSuccess() {
      const res = pruefPlanStores.getDeleteChecklistTemplateResult();
      if (res) {
        toast.success(localization.templateDeleteSuccess);
        setGlobalSpinner(false);
        getChecklistTemplates();
      }
    }
    function deleteChecklistTemplateFailure() {
      const res = pruefPlanStores.getDeleteChecklistTemplateResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_SUCCESS,
      deleteChecklistTemplateSuccess
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_FAILURE,
      deleteChecklistTemplateFailure
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_SUCCESS,
        deleteChecklistTemplateSuccess
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_FAILURE,
        deleteChecklistTemplateFailure
      );
    };
  }, []);

  useEffect(() => {
    setModalClass(showTemplateList ? "custom-modal" : "");
    return () => {};
  }, [showTemplateList]);

  const handleContinue = () => {
    setGlobalSpinner(true);
    getChecklistTemplates();
  };

  const handleContinueToChecklist = () => {
    if (selectedTemplateData && selectedTemplateData.length == 1) {
      setAddChecklistModalOpen(true);
      setviewModeOnly(false);
      setIsChecklistFromTemplate(true);
      getCheckListDetails(selectedTemplateData[0]);
    }
  };

  return (
    <div
      className="modal in dialogBox"
      id="addChecklistPopUp"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addChecklistPopUp"
      aria-hidden="true"
      data-backdrop="static"
      data-focus="false"
    >
      <div className={modalClass + " modal-dialog"} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addChecklistPopUpTitle">
              {localization.createNewChecklist}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addChecklistPopUpModalClose"
              onClick={() => {
                setSelectedType("");
                setChecklistTemplateList(false);
                setShowTemplateList(false);
                setAddChecklistModalOpen(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            {!showTemplateList && (
              <div className="d-flex">
                <div className="form-group">
                  <button
                    type="button"
                    className={
                      selectedType == "TEMPLATE"
                        ? "mb-4 mr-5 selectionBtn active"
                        : "mb-4 mr-5 selectionBtn"
                    }
                    onClick={() => {
                      setSelectedType("TEMPLATE");
                    }}
                  >
                    <div className="d-block text-center">
                      <SpaceDashboardOutlinedIcon
                        style={{ fontSize: "50px" }}
                      />
                    </div>
                    {localization.createFromTemplate}
                  </button>
                </div>

                <div className="form-group">
                  <button
                    type="button"
                    className={
                      selectedType == "SCRATCH"
                        ? "mb-4 selectionBtn active"
                        : "selectionBtn"
                    }
                    onClick={() => {
                      setSelectedType("SCRATCH");
                      setviewModeOnly(false);
                    }}
                  >
                    <div className="d-block text-center">
                      <AddOutlinedIcon style={{ fontSize: "50px" }} />
                    </div>
                    {localization.createFromScratch}
                  </button>
                </div>
              </div>
            )}

            {showTemplateList && (
              <>
                <h3>{localization.listOfTemplates}</h3>
                <TemplateList
                  tableRenderData={checklistTemplateList}
                  getCheckListDetails={getCheckListDetails}
                  setviewModeOnly={setviewModeOnly}
                  setDisableContinueButton={setDisableContinueButton}
                  setSelectedTemplateData={setSelectedTemplateData}
                  handleActionButtons={handleActionButtons}
                />
              </>
            )}
            <hr></hr>
          </div>
          <div className="modal-footer">
            <div
              className="d-flex w-100"
              style={{ justifyContent: "space-between" }}
            >
              {!showTemplateList && (
                <div className="">
                  <button
                    type="button"
                    className="pl-4 pr-4 pt-3 pb-3 cancelActionBtn"
                    onClick={() => {
                      commonUtils.hideModalPopUp("addChecklistPopUpModalClose");
                      setAddChecklistModalOpen(false);
                    }}
                  >
                    {localization.abort}
                  </button>
                </div>
              )}

              {showTemplateList && (
                <div className="">
                  <button
                    type="button"
                    className="pl-4 pr-4 pt-3 pb-3 cancelActionBtn"
                    onClick={() => {
                      setShowTemplateList(false);
                      setDisableContinueButton(false);
                      setSelectedTemplateData([]);
                    }}
                  >
                    {localization.back}
                  </button>
                </div>
              )}

              <div className="">
                {selectedType == "SCRATCH" && (
                  <button
                    type="button"
                    className="publishChecklistBtnCls pl-4 pr-4 pt-3 pb-3"
                    data-toggle="modal"
                    data-target="#addDigitalChecklist"
                    onClick={() => {
                      setIsChecklistFromTemplate(false);
                      commonUtils.hideModalPopUp("addChecklistPopUpModalClose");
                    }}
                  >
                    {localization.continueButton}
                  </button>
                )}

                {selectedType == "TEMPLATE" &&
                  selectedTemplateData &&
                  selectedTemplateData.length != 1 &&
                  !disableContinueButton && (
                    <button
                      type="button"
                      className="publishChecklistBtnCls pl-4 pr-4 pt-3 pb-3"
                      onClick={handleContinue}
                    >
                      {localization.continueButton}
                    </button>
                  )}

                {selectedType == "TEMPLATE" &&
                  selectedTemplateData &&
                  selectedTemplateData.length == 1 && (
                    <button
                      type="button"
                      className="publishChecklistBtnCls pl-4 pr-4 pt-3 pb-3"
                      data-toggle="modal"
                      data-target="#addDigitalChecklist"
                      onClick={handleContinueToChecklist}
                    >
                      {localization.continueButton}
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
